import { render } from "./Calls_quota.vue?vue&type=template&id=51230161&scoped=true"
import script from "./Calls_quota.vue?vue&type=script&lang=js"
export * from "./Calls_quota.vue?vue&type=script&lang=js"

import "./Calls_quota.vue?vue&type=style&index=0&id=51230161&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51230161"]])

export default __exports__